export const CAMPAIGNS_MODALS = {
    CAMPAIGN_ADD: 'campaign-add',
    CAMPAIGN_UPDATE: 'campaign-update',
}
